export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <div className="brand">
      <span className="brand-name">evocha</span>
      <span className="brand-line">Admin Portal</span>
    </div>
  );
}